var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sites-filter-toolbar" },
    [
      _c("CommonFilterTool", {
        attrs: {
          "filter-meta": _vm.filterMetas,
          "label-formatter": _vm.filterLabelFormatter,
          "show-add-button": true,
          "filter-templates": _vm.getFilterTemplates(),
          "selected-filter-template": _vm.getSelectedFilterTemplateName(),
          "required-filters": _vm.getRequiredBreakdowns(),
        },
        on: {
          addFilter: _vm.addFilter,
          applyFilterTemplate: _vm.applyFilterTemplate,
        },
        model: {
          value: _vm.siteFilters,
          callback: function ($$v) {
            _vm.siteFilters = $$v
          },
          expression: "siteFilters",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }